import * as yup from 'yup'

/**
 * Schemas de validação do módulo de Perfil (mensagens em pt-BR).
 * Consumidos por PersonalDataPanel e SecurityPanel.
 */

const cpfIsValid = (value?: string | null): boolean => {
  if (!value) return true // opcional — vazio é válido; obrigatoriedade é tratada à parte
  const digits = value.replace(/\D/g, '')
  if (digits.length !== 11) return false
  if (/^(\d)\1{10}$/.test(digits)) return false // todos iguais

  const calcCheckDigit = (base: string, factor: number): number => {
    let total = 0
    for (const digit of base) total += Number(digit) * factor--
    const rest = (total * 10) % 11
    return rest === 10 ? 0 : rest
  }

  const firstCheck = calcCheckDigit(digits.slice(0, 9), 10)
  const secondCheck = calcCheckDigit(digits.slice(0, 10), 11)
  return firstCheck === Number(digits[9]) && secondCheck === Number(digits[10])
}

const brDateIsValid = (value?: string | null): boolean => {
  if (!value) return true
  const digits = value.replace(/\D/g, '')
  if (digits.length !== 8) return false
  const day = Number(digits.slice(0, 2))
  const month = Number(digits.slice(2, 4))
  const year = Number(digits.slice(4, 8))
  const currentYear = new Date().getFullYear()
  if (year < 1900 || year > currentYear) return false
  // Valida o dia real do mês (rejeita 31/04, 29/02 fora de bissexto, etc.).
  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

export const personalDataSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required('Informe seu nome')
    .min(3, 'O nome deve ter ao menos 3 caracteres'),
  email: yup.string().trim().required('Informe seu e-mail').email('E-mail inválido'),
  cpf: yup
    .string()
    .nullable()
    .test('cpf-valido', 'CPF inválido', (value) => cpfIsValid(value)),
  birthDate: yup
    .string()
    .nullable()
    .test('data-valida', 'Data de nascimento inválida', (value) => brDateIsValid(value)),
  phoneNumber: yup
    .string()
    .nullable()
    .test('telefone-valido', 'Telefone inválido', (value) => {
      if (!value) return true
      const digits = value.replace(/\D/g, '')
      return digits.length === 0 || digits.length === 10 || digits.length === 11
    })
})

export const passwordSchema = yup.object().shape({
  currentPassword: yup.string().required('Informe sua senha atual'),
  password: yup
    .string()
    .required('Informe a nova senha')
    .min(8, 'A senha deve ter ao menos 8 caracteres')
    .matches(/[A-Za-z]/, 'A senha deve conter ao menos uma letra')
    .matches(/\d/, 'A senha deve conter ao menos um número'),
  repeatPassword: yup
    .string()
    .required('Confirme a nova senha')
    .oneOf([yup.ref('password')], 'As senhas não coincidem')
})
